import React from 'react';
import type { Daypart } from '../../types/stage';
const glows: Record<Daypart, {
  color: string;
  strength: number;
}> = {
  ochtend: {
    color: '43 169 181',
    strength: 0.26
  },
  focus: {
    color: '125 135 152',
    strength: 0.1
  },
  middag: {
    color: '79 179 176',
    strength: 0.19
  },
  avond: {
    color: '224 149 74',
    strength: 0.24
  },
  nacht: {
    color: '0 0 0',
    strength: 0
  },
  alarm: {
    color: '200 96 63',
    strength: 0.12
  }
};

/** Background layer: soft radial glow behind Anna, following time of day and house mode. */
export function WallAtmosphere({
  daypart,
  cy = '46%'
}: {
  daypart: Daypart;
  cy?: string;
}) {
  return <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-1558" data-mp="kyyf7abutkcr">
      {(Object.keys(glows) as Daypart[]).map(key => {
      const g = glows[key];
      return <div key={key} className="absolute inset-0 transition-opacity duration-1000 ease-out" style={{
        opacity: key === daypart ? 1 : 0,
        background: `radial-gradient(ellipse 60% 66% at 50% ${cy}, rgb(${g.color} / ${g.strength}), rgb(${g.color} / ${g.strength * 0.3}) 45%, transparent 80%)`
      }} data-id="element-1559" data-mp="3pd6ejrmmbvdt" />;
    })}
    </div>;
}